import { useQuery } from '@tanstack/react-query';
import { accountsMeRetrieve } from '@wellstone-solutions/api/v2';

import type { AuthUser } from '@wellstone-solutions/api/v2';

const fetchMe = async (accessToken: string): Promise<AuthUser> => {
  const res = await accountsMeRetrieve({
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return res.data;
};

const useMe = (accessToken: string | null) => {
  return useQuery<AuthUser>({
    queryKey: ['me'],
    queryFn: () => fetchMe(accessToken!),
    enabled: !!accessToken,
  });
};

export { useMe, fetchMe };
